import React from "react"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import { useSelector } from "react-redux"
import { RadioButton } from "shared/inputs"
import { store } from "store"
import { setSelectedGrouping, getTaskTable } from "reduxSlices/taskTableSlice"
import { GROUPABLE_COLUMNS } from "TaskList/taskGroupingHelper"

const TaskGroupBy = () => {
  const { selectedGroupingColumn } = useSelector(getTaskTable)
  const groupByColumnSelect = (column) => () => store.dispatch(setSelectedGrouping(column))

  return (
    <SidebarCollapsibleContent title="Group By">
      {
        Object.entries(GROUPABLE_COLUMNS).map(([, { label, value }]) => (
          <div
            key={value}
            className="sidebar-border-wrap last:mb-0 cursor-pointer text-sm font-medium"
            onClickCapture={groupByColumnSelect(value)}
          >
            <RadioButton
              className="flex-row-reverse justify-between"
              label={label}
              value={value}
              onChange={groupByColumnSelect(value)}
              checked={value === selectedGroupingColumn.value}
            />
          </div>
        ))
      }
    </SidebarCollapsibleContent>
  )
}

export default TaskGroupBy
